import React from 'react';

const PageHeader = ({ icon: Icon, badge, title, description, children }) => (
  <div className="mb-6">
    {badge && badge !== title && (
      <p className="text-[10px] font-bold uppercase tracking-widest text-brand-muted mb-1">{badge}</p>
    )}
    <div className="flex items-center gap-3">
      {Icon && <Icon className="h-6 w-6 shrink-0 text-brand-accent" />}
      <h1 className="text-xl font-bold text-brand-text">{title}</h1>
    </div>
    {description && <p className="text-sm text-brand-muted mt-2 max-w-2xl">{description}</p>}
    {children}
  </div>
);

export default PageHeader;
